import { Popup, PopupOptions } from "../abstractions/Popup.js";

/**
 * Single-Level-Bar behaviour for the
 * composition within responsive menus
 */
export class Bar extends Popup {
    private menu: HTMLElement;
    public submenuContainer: HTMLElement | null = null;

    /**
     * Constructor of the Bar
     *
     * @param {HTMLElement} scope
     * @param {PopupOptions} options
     */
    public constructor(scope: HTMLElement, options: PopupOptions) {
        super(options);

        const selector = `[scope="header-main-menu-behaviour"][template="bar"]`;
        this.menu = scope.querySelector<HTMLElement>(selector)!;

        this.levels = this.createLevels(this.menu);
    }

    /**
     * Method to apply the functionality
     *
     * @returns {void}
     */
    public apply(): void {
        this.levels.forEach((level) => level.apply());
        document.addEventListener("click", this.handleDocumentClick);
    }

    /**
     * Method to destroy the functionality
     *
     * @returns {void}
     */
    public destroy(): void {
        this.levels.forEach((level) => level.destroy());
        document.removeEventListener("click", this.handleDocumentClick);
    }

    /**
     * Method to handle the click outside the menu to close it
     *
     * @param {MouseEvent} event
     * @returns {void}
     */
    private handleDocumentClick = (event: MouseEvent): void => {
        const target = event.target as HTMLElement;
        if (this.menu && !this.menu.contains(target)) {
            this.closeSubmenus();
        }
    };
}
